import { Box, IconButton, Typography } from "@mui/material";
import { EvidenceItem } from "../../models/Evidence";
import { useEffect, useState } from "react";
import FileUtils from "../../utils/fileUtils";
import alertService from "../alert/alertService";
import { useTranslation } from "react-i18next";
import { common, input } from "../../i18n";
import ActivitiesService from "../../service/activities.service";

export interface Props {
  attachment: string;
  attachmentRef: string;
  deleteFile: () => void;
  evidenceList: EvidenceItem[];
}

export const SelectedFile = ({
  attachment,
  attachmentRef,
  deleteFile,
  evidenceList,
}: Props): JSX.Element | null => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const [error, setError] = useState<string | undefined>();

  const [fileName, setFileNmae] = useState<string | undefined>();

  const previewFile = async () => {
    let previewFileUrl: string | undefined;

    if (attachment !== "" && attachment) {
      const file = FileUtils.base64ToFile(attachment);

      if (!FileUtils.canOpenInNewTab(file.type)) {
        alertService.error(t("Cannot-Preview-File"), t("Note"));
        return;
      }

      previewFileUrl = URL.createObjectURL(file);
    } else if (attachmentRef !== "" && attachmentRef) {
      const file = await ActivitiesService.getAttachment(attachmentRef!);

      if (file) {
        previewFileUrl = file.evidenceS3Url;
      }
    }
    if (previewFileUrl !== "" && previewFileUrl) {
      window.open(previewFileUrl);
    }
  };

  useEffect(() => {
    if (attachment !== "" && attachment) {
      try {
        const file = FileUtils.base64ToFile(attachment);

        setFileNmae(file.name);

        setError(undefined);
      } catch (error) {
        alertService.error(t("Cannot-Preview-Evidence"));
        setFileNmae(attachment);
        setError(attachment);
      }
    } else if (attachmentRef !== "" && attachmentRef) {
      const item = evidenceList.find((r) => r.attachmentRef === attachmentRef);

      if (item) {
        setFileNmae(item.evidenceFileName);
        setError(undefined);
      }
    }
  }, [attachmentRef, attachment]);

  // Early return if no file name
  if (!fileName) {
    return (
      <Box height={"63.5px"} alignContent={"center"}>
        <Typography variant="text1">{t("No-File-Selected")}</Typography>
      </Box>
    );
  }

  return (
    <Box
      display={"flex"}
      columnGap={"14px"}
      alignItems={"center"}
      sx={{
        border: "1px solid var(--gray4)",
        padding: "8px",
        borderRadius: "8px",
      }}
      width={{ xs: "auto", md: "40%" }}
    >
      <Typography
        variant="text1"
        flex={1}
        style={{
          display: "-webkit-box",
          overflow: "hidden",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
        }}
        key={fileName}
      >
        {fileName}
      </Typography>
      <IconButton
        color="info"
        aria-label="previewFile"
        onClick={previewFile}
        sx={{
          height: "40px",
          backgroundColor: "var(--Scope-1-Refrigerant)",
          "&:hover": {
            backgroundColor: "var(--Scope-1-Refrigerant)",
            opacity: 0.75,
          },
          display: error ? "none" : "block",
        }}
      >
        <img src="/img/eye.svg" alt="preview" />
      </IconButton>
      <IconButton
        color="error"
        aria-label="delete"
        onClick={deleteFile}
        sx={{
          backgroundColor: "var(--status-rejected-failed-bg)",
          "&:hover": {
            backgroundColor: "var(--status-rejected-failed-bg)",
            opacity: 0.75,
          },
        }}
      >
        <img src="/img/delete.svg" alt="icon-delete" />
      </IconButton>
    </Box>
  );
};
